import { STRINGS } from '../../constants';
import filterEmptyParams from '../../utils/filters';
import apiCaller from '../http';
import URLS from '../urls';

const proposeNewVisitTime = async (
  visitId,
  values,
  setError,
  setIsLoading,
  setIsModalVisible,
  refresh,
  logoutHandler,
) => {
  const payload = {
    first_proposition: values?.firstProposition,
    second_proposition: values?.secondProposition,
  };
  await apiCaller
    .put(`${URLS.VISIT_PROPOSE_NEW_TIME}${visitId}/`, filterEmptyParams(payload))
    .then((resp) => {
      if (resp.data !== undefined) {
        setError(null);
        setIsLoading(false);
        setIsModalVisible(false);
        refresh();
      } else {
        setError(STRINGS.common.error404Text);
      }
    })
    .catch((e) => {
      if (e.message === STRINGS.common.errorMissingCredentials) {
        logoutHandler();
      }
      if (e.message === STRINGS.common.error400Template) {
        setError(STRINGS.common.error400Text);
      }
    });
};

export default proposeNewVisitTime;
